import { ControlTypes } from '@nx-customer-apps/shared/enums';
import { QuestionGroupBase } from './question-group-base.model';
import { SingleQuestion } from '../types';

export class MultiQuestionbox extends QuestionGroupBase<SingleQuestion[]> {
    override controlType = ControlTypes.MultiQuestionbox;
}
